/* PUSHAS 2026 - PDP buy box CRO layer. Loaded from layout/theme.liquid after pushas-2026.js.
   1. Moves the share button out of the add-to-cart row and up beside the product title.
   2. Mirrors the sticky add-to-cart state onto <html> so the mobile toolbar can stand down,
      and re-seats the bar against the bottom edge when it does.
   3. Points the size-guide link at the current /pages/size-guide URL. */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;

  function moveShare() {
    var share = document.querySelector('share-button.productView-share');
    var title = document.querySelector('.productView-title');
    if (!share || !title) return;
    var host = title.parentNode;
    if (!host || share.parentNode === host) return;
    host.classList.add('p26-titlerow');
    host.appendChild(share);
  }

  function fixGuideLink() {
    var a = document.querySelector('.p26-sizes-guide');
    if (a && (a.getAttribute('href') || '').indexOf('size-chart-for-nike') > -1) a.setAttribute('href', '/pages/size-guide');
  }

  /* The sticky bar is built by pushas-2026.js and toggles .is-on. Mirror that onto <html>
     so CSS can hide the theme toolbar underneath, then re-seat the bar's bottom offset. */
  var watching = false;
  function watchSticky() {
    if (watching) return true;
    var bar = document.querySelector('.p26-sticky');
    if (!bar || !('MutationObserver' in window)) return false;
    watching = true;
    function seat() {
      var tb = document.querySelector('.halo-sticky-toolbar-mobile, .halo-toolbar-mobile, .toolbar-mobile');
      var stacked = tb && tb.offsetHeight && getComputedStyle(tb).display !== 'none' && window.innerWidth < 1025;
      bar.style.bottom = stacked ? tb.offsetHeight + 'px' : '0px';
    }
    var last = null;
    function sync() {
      var on = bar.classList.contains('is-on');
      if (on === last) return;
      last = on;
      document.documentElement.classList.toggle('p26-sticky-on', on);
      seat();
    }
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', seat, { passive: true });
    sync();
    return true;
  }

  function init() {
    try { moveShare(); } catch (e) {}
    try { fixGuideLink(); } catch (e) {}
    if (!watchSticky()) {
      var n = 0;
      var t = setInterval(function () { if (watchSticky() || ++n > 40) clearInterval(t); }, 200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Re-apply after the theme re-renders the buy box on a variant change. */
  var host = document.querySelector('.productView-details');
  if (host && 'MutationObserver' in window) {
    var d;
    new MutationObserver(function () {
      clearTimeout(d);
      d = setTimeout(function () { try { moveShare(); fixGuideLink(); } catch (e) {} }, 200);
    }).observe(host, { childList: true, subtree: true });
  }
})();
